<template>
  <section>
    <Header />
    <section v-if="true" class="flex flex-col items-center w-full">
      <secondary-banner :withBorder="false" />
      <text-image-container :withBorder="false" />
      <first-carousel />
      <first-banner />
      <pre-footer />
    </section>
    <Footer />

    <div class="py-12">
      <div class="w-full border-t border-gray-300"></div>
    </div>
    <Header />
    <section v-if="true" class="flex flex-col items-center w-full">
      <secondary-banner />
      <tertiary-banner />
      <secondary-carousel />
      <tabs-container :withBorder="false" />
    </section>
    <Footer />

    <div class="py-12">
      <div class="w-full border-t border-gray-300"></div>
    </div>

    <Header />
    <section v-if="true" class="flex flex-col items-center w-full">
      <banner-form />
      <simple-text-carousel />
      <tertiary-banner />
      <dropdown-banner :withBorder="false" />
    </section>
    <Footer />

    <div class="py-12">
      <div class="w-full border-t border-gray-300"></div>
    </div>

    <Header />
    <section v-if="true" class="flex flex-col items-center w-full">
      <text-image-banner :withBorder="false" />
      <secondary-form :withBorder="false" />
      <primary-content-container :withBorder="false" />
      <tertiary-carousel /> -->
    </section>
    <Footer />

    <div class="py-12">
      <div class="w-full border-t border-gray-300"></div>
    </div>

    <Header />
    <section v-if="true" class="flex flex-col items-center w-full">
      <tertiary-form :withBorder="false" />
      <box-container :withBorder="false" />
      <list-banner :withBorder="false" />
    </section>
    <Footer />
  </section>
</template>
<script>
export default {
  components: {
    Footer: () => import("../sections/Footer.vue"),
    Header: () => import("../sections/Header.vue"),
    FirstForm: () => import("../sections/FirstForm.vue"),
    TextImageContainer: () => import("../sections/TextImageContainer.vue"),
    FirstCarousel: () => import("../sections/FirstCarousel.vue"),
    FirstBanner: () => import("../sections/FirstBanner.vue"),
    PreFooter: () => import("../sections/PreFooter.vue"),

    SecondaryBanner: () => import("../sections/SecondaryBanner.vue"),
    TertiaryBanner: () => import("../sections/TertiaryBanner.vue"),
    SecondaryCarousel: () => import("../sections/SecondaryCarousel.vue"),
    TabsContainer: () => import("../sections/TabsContainer.vue"),

    BannerForm: () => import("../sections/BannerForm.vue"),
    SimpleTextCarousel: () => import("../sections/SimpleTextCarousel.vue"),
    DropdownBanner: () => import("../sections/DropdownBanner.vue"),

    TextImageBanner: () => import("../sections/TextImageBanner.vue"),
    SecondaryForm: () => import("../sections/SecondaryForm.vue"),
    PrimaryContentContainer: () =>
      import("../sections/PrimaryContentContainer.vue"),
    TertiaryCarousel: () => import("../sections/TertiaryCarousel.vue"),

    TertiaryForm: () => import("../sections/TertiaryForm.vue"),
    BoxContainer: () => import("../sections/BoxContainer.vue"),
    ListBanner: () => import("../sections/ListBanner.vue"),
  },
};
</script>
